import React, { useState, useMemo, useEffect, useRef } from "react";
import "./Tabs.css";
import DimensionsTab from "src/components/Tabs/DimensionsTab/DimensionsTab";
import WallsTab from "src/components/Tabs/WallsTab/WallsTab";
// import RoofingTab from "src/components/Tabs/RoofingTab/RoofingTab";
import MaterialsListTab from "src/components/Tabs/MaterialsListTab/MaterialsListTab";
// import OptiesTab from "src/components/Tabs/OptiesTab/OptiesTab";

import { useView } from "src/contexts/ViewContext";
import RoofTypeTab from "src/components/Tabs/RoofTypeTab/RoofTypeTab";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { getConfigurationHash } from "src/helpers/configuration";
import { useTabScroll } from "src/contexts/TabScrollContext";
import SunScreenTab from "./SunScreenTab/SunScreenTab";
import OptiesTab from "src/components/Tabs/FunderingTab/OptiesTab";
// import { Configuration } from "src/types/configuration";

interface TabConfig {
  id: number;
  title: string;
  component: React.ReactNode;
  description?: string;
}

interface TabProps {
  tab: {
    id: number;
    title: string;
    component: React.ReactNode;
  };
  isActive: boolean;
  onClick: () => void;
  onNext?: () => void;
  onPrev?: () => void;
  hidden: boolean;
  isCompleted: boolean;
  description?: string;
  isLast?: boolean;
}

const tabsData: TabConfig[] = [
  {
    id: 1,
    title: "Dak constructie",
    component: <RoofTypeTab />,
  },
  {
    id: 2,
    title: "Kleur & Dak",
    component: <DimensionsTab />,
  },
  {
    id: 3,
    title: "Wanden",
    component: <WallsTab />,
  },
  {
    id: 4,
    title: "Accessoires",
    component: <SunScreenTab />,
  },
  {
    id: 5,
    title: "Opties",
    component: <OptiesTab />,
  },
  {
    id: 7,
    title: "Materiaallijst",
    component: <MaterialsListTab />,
  },
];

const CheckIcon: React.FC = () => <span>✓</span>;

const ArrowIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M16 12L10 6L8.59 7.41L13.17 12L8.59 16.59L10 18L16 12Z"
      fill="currentColor"
    />
  </svg>
);

const PrevIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="45"
    viewBox="0 0 55 45"
    fill="none"
  >
    <path
      d="M32.0115 14.5898L23.8801 21.394C23.1454 22.0088 23.1454 22.9912 23.8801 23.606L32.0115 30.4102"
      stroke="currentColor"
      strokeWidth="2.14844"
      strokeLinecap="round"
    />
  </svg>
);

const NextIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="19"
    viewBox="0 0 12 19"
    fill="none"
  >
    <path
      d="M1.98849 17.4102L10.1199 10.606C10.8546 9.9912 10.8546 9.0088 10.1199 8.39398L1.98849 1.58984"
      stroke="currentColor"
      strokeWidth="2.14844"
      strokeLinecap="round"
    />
  </svg>
);

const Tab: React.FC<TabProps> = ({
  tab,
  isActive,
  onClick,
  hidden,
  onNext,
  onPrev,
  isCompleted,
  isLast,
  description,
}) => {
  if (hidden) return null;

  return (
    <div className={`tab${isActive ? " open" : ""}`} id={`tab-${tab.id}`}>
      <div
        className={`tab-header ${isActive ? "open" : ""} ${
          isCompleted ? "completed" : ""
        }`}
        onClick={onClick}
      >
        {/* <div className="relative"> */}
        {!isCompleted && (
          <span
            className={`tab-number${description ? " infohovertarget" : ""}${
              isActive ? " active" : ""
            }`}
          >
            {tab.id}
          </span>
        )}
        {isCompleted && <CheckIcon />}

        {/* {description && <div className="infohover">{description}</div>} */}
        {/* </div> */}
        <span>{tab.title.toUpperCase()}</span>
        {/* <div className="arrow-icon"> */}
        <ArrowIcon />
        {/* </div> */}
      </div>
      {isActive && (
        <div className="tab-content">
          {tab.component}
          <div className="tab-navigation">
            {onPrev && (
              <button
                title="Previous"
                className={"prevButton"}
                onClick={() => {
                  onPrev();
                }}
              >
                <PrevIcon />
              </button>
            )}
            {onNext && (
              <button
                title="Next"
                className={"nextButton"}
                onClick={() => {
                  onNext();
                }}
              >
                {isLast ? "Gereed" : "Volgende"}
                <NextIcon />
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

const Tabs: React.FC = () => {
  const configurationHash = getConfigurationHash();
  const [activeTabs, setActiveTabs] = useState<Set<number>>(new Set());
  const [completedTabs, setCompletedTabs] = useState<Set<number>>(
    new Set(configurationHash ? tabsData.map((t) => t.id) : [])
  );
  const { isAdmin } = useView();
  const { configurator, setUncompletedTabs, state, setLights } =
    useConfiguration();
  const { scrollRef } = useTabScroll();
  const lastClickWasWanden = useRef<boolean>(false);

  const scrollWithinContainer = (
    element: HTMLElement,
    block: ScrollLogicalPosition = "start"
  ) => {
    const scrollContainer =
      scrollRef.current ||
      element.closest(".scroll") ||
      (document.querySelector(".scroll") as HTMLElement | null);

    if (!scrollContainer) {
      element.scrollIntoView({ behavior: "smooth", block });
      return;
    }

    const containerRect = scrollContainer.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();

    let delta = elementRect.top - containerRect.top;
    if (block === "center") {
      delta -= scrollContainer.clientHeight / 2 - elementRect.height / 2;
    }

    scrollContainer.scrollTo({
      top: scrollContainer.scrollTop + delta,
      behavior: "smooth",
    });
  };

  const onTabChange = (tabId: number) => {
    setTimeout(() => {
      configurator.deselectWalls();
      const tabElement = document.querySelector(
        `#tab-${tabId}`
      ) as HTMLElement | null;
      if (tabElement) {
        scrollWithinContainer(tabElement);
      }
    }, 80);
  };

  const visibleTabs = useMemo(() => {
    return tabsData.filter((tab) => {
      if (tab.id !== 7) return true;
      return isAdmin();
    });
  }, [isAdmin]);

  const handleOutWandenClick = (e: React.MouseEvent<HTMLDivElement>) => {
    const wandenElement = document.getElementById("tab-5");
    const clickedInsideTab5 = wandenElement
      ? wandenElement.contains(e.target as Node)
      : false;

    if (clickedInsideTab5) {
      lastClickWasWanden.current = true;
    } else {
      if (lastClickWasWanden.current) {
        configurator.resetCamera();
      }

      lastClickWasWanden.current = false;
    }
  };

  const handleTabClick = (id: number) => {
    let newSet = new Set(activeTabs);
    configurator.resetCamera();

    if (state.lights.lightsOn) {
      setLights({ ...state.lights, lightsOn: false });
    }

    if (!newSet.has(id)) {
      newSet = new Set<number>();
      newSet.add(id);
      onTabChange(id);
    } else {
      newSet = new Set<number>();
    }

    configurator.deselectWalls();

    setActiveTabs(newSet);
  };

  const goToNextTab = () => {
    const currentTabId = Array.from(activeTabs)[0];
    if (!currentTabId) return;

    configurator.resetCamera();
    if (state.lights.lightsOn) {
      setLights({ ...state.lights, lightsOn: false });
    }

    const nextTab = visibleTabs.find((t) => t.id === currentTabId + 1);

    configurator.deselectWalls();

    if (currentTabId === 5) {
      configurator.resetCamera();
    }

    setCompletedTabs((prev) => {
      const newSet = new Set(prev);
      newSet.add(currentTabId);
      return newSet;
    });

    setActiveTabs((prev) => {
      const newSet = new Set(prev);
      newSet.delete(currentTabId);

      if (nextTab && !completedTabs.has(nextTab.id)) {
        newSet.add(nextTab.id);
      }

      return newSet;
    });

    if (nextTab && !completedTabs.has(nextTab.id)) {
      onTabChange(nextTab.id);
    }
  };

  const goToPrevTab = () => {
    if (state.lights.lightsOn) {
      setLights({ ...state.lights, lightsOn: false });
    }
    const currentTabId = Array.from(activeTabs)[0];
    if (!currentTabId) return;

    const prevTab = visibleTabs.find((t) => t.id === currentTabId - 1);
    if (!prevTab) return;

    configurator.deselectWalls();

    if (currentTabId === 5) {
      configurator.resetCamera();
    }

    setActiveTabs((prev) => {
      const newSet = new Set(prev);
      newSet.delete(currentTabId);

      if (prevTab) {
        newSet.add(prevTab.id);
      }

      return newSet;
    });

    if (prevTab && completedTabs.has(prevTab.id)) {
      const newSet = new Set(completedTabs);
      newSet.delete(prevTab.id);
      setCompletedTabs(newSet);
    }

    onTabChange(prevTab.id);
  };

  useEffect(() => {
    const uncompletedTabs = new Set(
      tabsData
        .filter((t) => !completedTabs.has(t.id) && t.id !== 7)
        .map((t) => t.id)
    );
    setUncompletedTabs(uncompletedTabs);
  }, [activeTabs, completedTabs, setUncompletedTabs]);

  return (
    <div className="scroll" ref={scrollRef}>
      <div className="tabs-container" onClick={handleOutWandenClick}>
        {visibleTabs.map((tab, index) => {
          const isActive = activeTabs.has(tab.id);
          const isCompleted = completedTabs.has(tab.id);
          const hasPrev = index > 0 && isActive;

          return (
            <Tab
              key={`main-tab-${tab.id}`}
              tab={tab}
              isActive={isActive}
              onClick={() => handleTabClick(tab.id)}
              hidden={false}
              onNext={isActive ? goToNextTab : undefined}
              onPrev={isActive && hasPrev ? goToPrevTab : undefined}
              isCompleted={isCompleted}
              description={tab.description}
              isLast={index === visibleTabs.length - 1}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
